export const NAME = "public/verifyEmail" as const;

export const CONFIRMATION_SEARCH_PARAM = "confirmation" as const;
